"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApiOrderRepo = createApiOrderRepo;
const HTTPClient_1 = require("../../../common/api/HTTPClient");
const http_helpers_1 = require("../../../common/api/http-helpers");
const ItemList_1 = require("../../../common/models/ItemList");
const OrderMapper_1 = require("./mappers/OrderMapper");
const getApiUrl_1 = require("../../../common/api/utils/getApiUrl");
function createApiOrderRepo() {
    return {
        getAll,
        getById,
        getSummary,
        checkOrders,
        createRefund,
    };
}
async function getAll(page = 1, pageSize = 10, filter = '', machineIds = [], clubIds = [], startDate = '', endDate = '', sort) {
    try {
        const sortParam = sort?.length
            ? sort.map((s) => `${s.field},${s.direction}`).join(';')
            : 'orderTime,desc';
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v2/orders`),
            params: {
                startDate,
                endDate,
                page,
                pageSize,
                filter,
                machineIds,
                clubIds,
                sort: sortParam,
            },
        });
        (0, http_helpers_1.sendSuccessStatus)();
        return {
            items: res.orders.map(OrderMapper_1.mapToDomainOrder),
            pagination: res.pagination,
            hasOrdersExceedingPreauth: res.hasOrdersExceedingPreauth ?? false,
        };
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return { ...(0, ItemList_1.emptyList)(), hasOrdersExceedingPreauth: false };
    }
}
async function getById(id) {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v2/orders/${id}`),
        });
        (0, http_helpers_1.sendSuccessStatus)();
        return (0, OrderMapper_1.mapToDomainOrderDetail)(res);
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return {};
    }
}
async function getSummary(filter = '', startDate = '', endDate = '', machineIds = [], clubIds = []) {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/orders/summary`),
            params: {
                filter,
                startDate,
                endDate,
                machineIds,
                clubIds,
            },
        });
        (0, http_helpers_1.sendSuccessStatus)();
        return res;
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return {};
    }
}
async function checkOrders(startTs, endTs) {
    try {
        const res = await HTTPClient_1.HTTPClient.post({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/orders/check-orders`),
            params: { startTs, endTs },
        });
        (0, http_helpers_1.sendSuccessStatus)();
        return res.map((dto) => (0, OrderMapper_1.mapToDomainCheckOrdersList)(dto));
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return [];
    }
}
async function createRefund(orderId, refund) {
    try {
        const res = await HTTPClient_1.HTTPClient.post({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/orders/${orderId}/returns`),
            body: refund,
            type: 'json',
        });
        (0, http_helpers_1.sendSuccessStatus)();
        return (0, OrderMapper_1.mapToDomainOrderDetail)(res);
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return {};
    }
}
